export default {
    ALL_SELECTED_OPTION: -1,
}